import api from './api'

class BlogService {
  static getBySlug = slug => {
    return api.call('get', `/blog/${slug}`).then(api.getData)
  }
}

export default BlogService
